import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Design } from './components';
import { Footer } from 'components';
import useEnrichedSchema from './useEnrichedSchema';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(3)
  },
  footer: {
    flexGrow: 0
  }
}));

const EnrichedSchemaDesign = () => {
  const schema = useEnrichedSchema();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Design
          schema={schema}
          showNav={true}
          back="/enriched-schema/details"
        />
      </div>
      {!schema.isLoading && schema.schemaObject && (
        <Footer className={classes.footer} />
      )}
    </div>
  );
};

export default EnrichedSchemaDesign;
